import React from "react";
import { useLocation } from "react-router-dom";
import { PublicSurfaceLink } from "../lib/xoPublicSurfaceLink";
import { isMessageBottleV2Path, navItemsForSidebar, navLabel, type XONavItem } from "../navigation/navConfig";
import "./Sidebar.css";

/**
 * Global site links (internal / control surfaces). Public product routes hide the sidebar in AppShell.
 * On Message Bottle V2, the column is slimmed so the Flow panel reads as primary.
 */
export const Sidebar = () => {
  const { pathname } = useLocation();
  const mb2Slim = isMessageBottleV2Path(pathname);
  const items = navItemsForSidebar();

  const navStyle: React.CSSProperties = mb2Slim
    ? {
        padding: "0.55rem 0.4rem",
        borderRight: "1px solid rgba(200, 164, 77, 0.14)",
        width: "6.25rem",
        minWidth: "6rem",
        maxWidth: "7rem",
        flexShrink: 0,
        alignSelf: "stretch",
        background: "linear-gradient(180deg, rgba(30,27,22,0.96) 0%, rgba(24,21,18,0.98) 100%)",
        boxShadow: "inset -1px 0 0 rgba(255,255,255,0.04)",
      }
    : {
        padding: "1rem",
        borderRight: "1px solid rgba(200, 164, 77, 0.24)",
        flexShrink: 0,
        alignSelf: "stretch",
      };

  const itemStyle = (_item: XONavItem): React.CSSProperties => ({
    display: "block",
    marginBottom: mb2Slim ? "0.4rem" : "0.5rem",
    fontSize: mb2Slim ? "0.64rem" : "inherit",
    lineHeight: mb2Slim ? 1.25 : undefined,
    wordBreak: "break-word",
    color: mb2Slim ? "rgba(246, 240, 230, 0.72)" : undefined,
    textDecoration: "none",
    fontWeight: mb2Slim ? 500 : undefined,
    letterSpacing: mb2Slim ? "0.02em" : undefined,
  });

  return (
    <nav
      className={mb2Slim ? "xo-site-sidebar xo-site-sidebar--compact" : "xo-site-sidebar"}
      style={navStyle}
      aria-label={mb2Slim ? "Secondary links; primary navigation is in the flow panel" : "Primary site navigation"}
    >
      {mb2Slim ? (
        <p style={{ margin: "0 0 0.45rem", fontSize: "0.55rem", color: "rgba(246, 240, 230, 0.45)", fontWeight: 600, letterSpacing: "0.14em", textTransform: "uppercase" }}>
          Elsewhere
        </p>
      ) : null}
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {items.map((item) => (
          <li key={item.id}>
            <PublicSurfaceLink to={item.path} style={itemStyle(item)} title={navLabel(item, "sidebar")}>
              {item.sidebarPrefix ?? ""}
              {navLabel(item, "sidebar")}
            </PublicSurfaceLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
